import { render, staticRenderFns } from "./PerformanceAssignmentList.vue?vue&type=template&id=1a785ed8&scoped=true&"
import script from "./PerformanceAssignmentList.vue?vue&type=script&lang=js&"
export * from "./PerformanceAssignmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a785ed8",
  null
  
)

export default component.exports